export default "__VITE_ASSET__BH4PLKrU__"